/**
 * PAGE ID
 */

export const PAGE_ID_HOME = "home";
export const PAGE_ID_MEMBER = "member";
export const PAGE_ID_MEMBER_ADMIN = "member_admin";
export const PAGE_ID_MEMBER_MANAGER = "member_manager";
export const PAGE_ID_MEMBER_USER = "member_user";
export const PAGE_ID_ROOM = "room";
export const PAGE_ID_ROOM_CURRENT = "room_current";
export const PAGE_ID_ROOM_RESV = "room_resv";
export const PAGE_ID_ROOM_RESV_CANCEL = "room_resv_cancel";
export const PAGE_ID_ROOM_PRODUCT = "room_product";
export const PAGE_ID_ROOM_HISTORY = "room_history";
export const PAGE_ID_ROOM_OPTION = "room_option";
export const PAGE_ID_ROOM_ROOM = "room_room";

export const LOGIN_FORM_ID_LOGIN = "login-form-login";

export const SEARCH_FORM_ID_MANAGER = "search-form-manager";
export const SEARCH_FORM_ID_USER = "search-form-user";

export const SEARCH_FORM_ID_ROOM_OPTION = "search-form-room-option";
export const UPDATE_BASE_FORM_ID_ROOM_OPTION = "update-base-form-room-option";
export const UPDATE_ADDINF_FORM_ID_ROOM_OPTION =
  "update-addInf-form-room-option";
export const CREATE_BASE_FORM_ID_ROOM_OPTION = "create-base-form-room-option";
export const CREATE_ADDINF_FORM_ID_ROOM_OPTION =
  "create-addInf-form-room-option";
export const SEARCH_FORM_ID_ROOM_ROOM = "search-form-room-room";
export const UPDATE_BASE_FORM_ID_ROOM_ROOM = "update-base-form-room-room";
export const UPDATE_ADDINF_FORM_ID_ROOM_ROOM = "update-addInf-form-room-room";
export const CREATE_BASE_FORM_ID_ROOM_ROOM = "create-base-form-room-room";
export const CREATE_ADDINF_FORM_ID_ROOM_ROOM = "create-addinf-form-room-room";
export const CREATE_IMG_FORM_ID_ROOM_ROOM = "create-img-form-room-room";
export const UPDATE_IMG_FORM_ID_ROOM_ROOM = "update-img-form-room-room";

export const SEARCH_FORM_ID_ROOM_RESV = "search-form-room-resv";
export const SEARCH_FORM_ID_ROOM_HISTORY = "search-form-room-history";

export const SEARCH_FORM_ID_ROOM_CANCEL_RESV = "search-form-room-cancel-resv";

export const SEARCH_ID_FORM_ROOM_PRODUCT = "search-form-room-product";
export const CREATE_FORM_ID_ROOM_PRODUCT = "create-form-room-product";
/*************** DISPATCH EVENT ACTION  ******************/

// 모달창 열기 이벤트 리스너
export const CONST_COMN_MODAL = "constComnOpenModal";

// 모달창 Inner 이벤트 리스너
export const CONST_COMN_MODAL_INNER = "constComnModalInner";

// 모달창 close 이벤트 리스너
export const CONST_COMN_MODAL_CLOSE = "constComnModalClose";

// 모달창 click 이벤트 리스너
export const CONST_COMN_MODAL_CLICK = "constComnModalClick";

// alert 이벤트 리스너
export const CONST_COMN_OPEN_ALERT = "constComnOpenAlert";

// 로딩 페이지 이벤트 리스너
export const CONST_COMN_LOAD_PAGE = "constComnLoadPage";

// post action 로딩 이벤트 리스너
export const CONST_COMN_POST_LOAD = "constComnPostLoad";

// 로그인 여부 이벤트 리스너
export const CONST_COMN_IS_LOGIN = "constComnIsLogin";

// useSettimeout 이벤트 리스너
export const CONST_COMN_SESSION_SETTIME_OUT = "constComnuseSettimeout"; // 사용여부 확인

// page select 이벤트 리스너
export const CONST_COMN_SELECT_PAGE = "constComnSelectPage";

// api 통신 성공 code === 0
export const CONST_COMN_API_DONE = "constComnApiDone";

//헤더 조회버튼 클리시 이벤트 리스너
export const COSNT_COMN_SEARCHFORM_ACTION = "constComnSearchformAction";

// 페이지네이션 nextpage 이벤트 리스너
export const CONST_COMN_PAGINATION_NEXT = "constComnPaginationNext";

// 검색폼에서 폼번검색 적용 이벤트 리스너
export const GONST_COMN_SEARCH_NO_GET_DATA = "constComnSearchNoGetData";

// editor reset
export const CONST_COMN_RESET_EDITOR = "constComnResetEditor";

// editor 입력 이벤트 리스터
export const CONST_COMN_EDITOR_VALUE = "constComnEditorValue";

// select 선택된 item dispatch 이벤트 리스너
export const CONST_COMN_SELECT_SELECTED_ITEM = "constComnSelectSelectedItem";

// handle upload img modal
export const CONST_COMN_UPDATE_IMG_MODAL = "constComnUpdateImgModal";

// image upload data
export const CONST_COMN_UPLOAD_IMG_DATA = "constComnuploadImgData";

// Top Bar 버튼 리스트 수정 이벤트 리스너
export const CONST_COMN_TOP_BAR_EVN_LIS_MODIFY = "constComnTopBarEvnLisModify";

// post

// 품번 검색 모달창에서 적용리스너
export const CONST_COMN_USE_SELECT = "constComnUseSelect";

/***************DISPATCH EVENT TARGET SET ******************/
export const constImgUpFormRstTarget = "create-img-form-result"; // 이미지 생성 페이지
export const constImgUpFormLstTarget = "comm-upload-img-list"; // 이미지컴포넌트 > ImgHead (등록버튼에서 처리)
export const constImgUpModalTarget = "com-upload-img-modal"; // 이미지수정 모달창 > imgUplad.tsx 등록 모달창
export const constImgMdfModalTarget = "modify-img-modal";

/*************** SEARCH FORM ID SET ******************/
export const CONST_USER_SEARCH_FORM_ID = "consUserSearchForm"; //회원조회폼
export const CONST_RM_RESV_SEARCH_FORM_ID = "consRmResvSearchForm"; //객실예약조회폼
export const CONST_RM_CNL_RESV_SEARCH_FORM_ID = "constRmCnlResvSearchForm"; //객실예약취소조회폼
export const CONST_RM_PD_SEARCH_FORM_ID = "constRmPdSearchForm"; //객실상품조회폼
export const CONST_RM_HST_SEARCH_FORM_ID = "consRmHstSearchForm"; //객실이력조회폼
export const CONST_RM_SEARCH_FORM_ID = "consRmSearchForm"; //객실조회폼
export const CONST_RM_OP_SEARCH_FORM_ID = "consRmOpSearchForm"; //객실옵션조회폼

/*************** UPLOAD IMAGE CODE ******************/
export const upRmFileCd = "I11"; //객실이미지업로드코드

/*************** GRID  ******************/
export const CONST_COMN_GRID_CELL_CHANGED = "constGridCellChanged";
